import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/Function.es.js";
const t = o.forwardRef((n, c) => /* @__PURE__ */ o.createElement(e, { ref: c, ...n, weights: r }));
t.displayName = "FunctionIcon";
const m = t;
export {
  m as Function,
  t as FunctionIcon
};
